/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Theme_DarkInputs */

const en_us2_profile_theme_dark = /** @type {(inputs: Profile_Theme_DarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dark`)
};

const pt_br2_profile_theme_dark = /** @type {(inputs: Profile_Theme_DarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escuro`)
};

const es_419_profile_theme_dark = /** @type {(inputs: Profile_Theme_DarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oscuro`)
};

const pt_pt2_profile_theme_dark = /** @type {(inputs: Profile_Theme_DarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escuro`)
};

const fr_fr2_profile_theme_dark = /** @type {(inputs: Profile_Theme_DarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sombre`)
};

const de_de2_profile_theme_dark = /** @type {(inputs: Profile_Theme_DarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dunkel`)
};

const it_it2_profile_theme_dark = /** @type {(inputs: Profile_Theme_DarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scuro`)
};

/**
* | output |
* | --- |
* | "Dark" |
*
* @param {Profile_Theme_DarkInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_theme_dark = /** @type {((inputs?: Profile_Theme_DarkInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Theme_DarkInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_theme_dark(inputs)
	if (locale === "es-419") return es_419_profile_theme_dark(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_theme_dark(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_theme_dark(inputs)
	if (locale === "de-DE") return de_de2_profile_theme_dark(inputs)
	if (locale === "it-IT") return it_it2_profile_theme_dark(inputs)
	return en_us2_profile_theme_dark(inputs)
});
export { profile_theme_dark as "profile.theme_dark" }